import { injectable } from 'tsyringe'
import Action from '@/common/action'

import type { ISize, Size } from '@/shared/di/interface/size'

export const VAULT_MENU_HEIGHT = 0
export const WALLET_MENU_HEIGHT = 0
@injectable()
export class SizeManager implements ISize {
  private menuHeight = VAULT_MENU_HEIGHT
  private isSSR = typeof window === 'undefined'
  private size = {
    width: !this.isSSR ? window.innerWidth : 1,
    height: !this.isSSR ? window.innerHeight - this.menuHeight : 1,
    sizeRatio: 1
  } as Size
  private onResizeDebouncedTimeout: number | undefined
  private forceUpdate = false

  private heightWidthoutKeyboard = -1
  private keyboardIsHiding = false

  onResize = new Action<Size | undefined>()

  constructor() {
    // render all pixels (highest quality)
    this.size.sizeRatio = !this.isSSR ? window.devicePixelRatio : 1

    // render enough pixels (highest performance)
    // this.size.sizeRatio = 1

    // conditional rendering
    /*
      if (!this.isSSR && isDesktop) {
        // render less pixels on mobile and ipad
        this.size.sizeRatio = window.devicePixelRatio
      }
    */

    if (!this.isSSR) {
      window.addEventListener('resize', this.resizeHandler)
      this.resizeHandler()
    }
  }

  private resizeHandler = () => {
    let newHeight = window.innerHeight

    if (this.keyboardIsHiding) {
      newHeight = this.heightWidthoutKeyboard
    }

    if (this.forceUpdate || this.size.width !== window.innerWidth || this.size.height !== newHeight) {
      this.forceUpdate = false
      this.size.width = window.innerWidth
      this.size.height = newHeight - this.menuHeight

      if (this.onResizeDebouncedTimeout) {
        window.clearTimeout(this.onResizeDebouncedTimeout)
      }

      this.onResizeDebouncedTimeout = window.setTimeout(() => {
        if (this.size.width !== window.innerWidth || this.size.height !== newHeight) {
          this.size.width = window.innerWidth
          this.size.height = newHeight - this.menuHeight
          this.onResize.invoke(this.size)
        }
      }, 500)

      this.onResize.invoke(this.size)
    }
  }

  setMenuHeight(height: number): void {
    this.menuHeight = height
    this.forceUpdate = true
    this.resizeHandler()
  }

  getSize(): Size {
    return this.size
  }

  triggerAction() {
    this.onResize.invoke(this.size)
  }
}
